import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";
import LoadingSpinner from '../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./toastify/config";
import apiCumbres from "../axios/axios";
import Swal from "sweetalert2";
import { useSelector } from 'react-redux';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import Tooltip from "./Tooltip";
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import ModalInfoPrestamoClientes from "./ModalInfoPrestamoClientes";

const sxTableHead = {
    color: "#f5f7fa", fontSize: "1.1rem", fontWeight: "bold"
}

const AutorizarPrestamoGrupal = () => {
    const tkn = useSelector((state) => state.tknAuth)
    const [isLoading, setIsLoading] = useState(false)
    const [prestamosPendientes, setPrestamosPendientes] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [idPrestamoGrupal, setIdPretamoGrupal] = useState(null)
    const [modalInfoPrestamoClientes, setModalInfoPrestamoClientes] = useState(false)


    const obtenerPrestamosAutorizar = () => {

        const prestamosParaAutorizar = async () => {

            try {
                setIsLoading(true)

                const obtener = await apiCumbres.get('/autorizar-prestamo/prestamos-grupal')

                setPrestamosPendientes(obtener.data)
                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener préstamos para autorizar, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        }

        prestamosParaAutorizar()

    }

    useEffect(() => {
        obtenerPrestamosAutorizar()
    }, [])

    const formatFecha = (value) => {

        const fecha = new Date(value + ' 08:00:00')
        const meses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']

        return `${fecha.getDate()} DE ${meses[fecha.getMonth()]} DE ${fecha.getFullYear()}`

    }

    const cambiarEstatusPrestamo = (e, estatus, estatus_text, pp) => {

        Swal.fire({
            title: "Esta seguro?",
            text: `Cambiara estatus de prestamo a ${estatus_text}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, cambiar!"
        }).then((result) => {
            if (result.isConfirmed) {

                const cambiarEstatus = async () => {
                    try {

                        setPrestamosPendientes(prev =>
                            prev.filter(p => p.contratoPrestamoGrupalId !== pp.contratoPrestamoGrupalId)
                        );

                        const cambiar = await apiCumbres.put(`/autorizar-prestamo/cambiar-estatus-grupal/${estatus}`, {
                            contratoPrestamoGrupalId: pp.contratoPrestamoGrupalId,
                            tipoIdPago: pp.tipoPagoId,
                            meses: pp.meses,
                            fechaPrimerPagoContrato: pp.fechaPrimerPagoContrato,
                            usuarioIdRegistro: tkn.usuarioId
                        })

                        obtenerPrestamosAutorizar()
                        toast.success(cambiar.data.mensaje, toast_config)

                    } catch (error) {
                        let msg_error = ''
                        if (error.response) {
                            console.log(error.response)
                            if (error.response.data.error) {
                                msg_error = error.response.data.error
                            } else {
                                msg_error = 'Ocurrió un error al cambiar estatus, favor de volver a intentarlo!'
                            }
                        } else {
                            console.log(error)
                            msg_error = 'No hay respuesta por parte del servidor!'
                        }
                        //mensaje de toastify
                        setIsLoading(false)
                        toast.error(msg_error, toast_config)
                    }
                }

                cambiarEstatus()

            }
        });

    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const verInformacionClientes = (e, id) => {

        //mostrar modal con los pagos, y si ya se pago o no, con las fechas en una tabla
        setIdPretamoGrupal(id)
        setModalInfoPrestamoClientes(true)

        //hacer template de contrato micro y personal

    }

    return (
        <div className="container">
            {isLoading ?
                <LoadingSpinner />
                : null}
            <div className="row">
                <div className="col-md-12">
                    <div
                        className="card shadow-lg  p-5 border-0"
                        style={{ borderRadius: '20px' }}
                    >

                        <div className="row">
                            <motion.h1 className="color-primary"
                                initial={{ opacity: 0, y: -90 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}>
                                Autorizar Préstamo Individual
                            </motion.h1>
                            <hr className="mb-5" />
                            <motion.div
                                initial={{ opacity: 0, y: 40 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.4 }}
                            >
                                <TableContainer component={Paper} sx={{ mt: 2 }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: "#0a2540" }}>
                                                <TableCell sx={sxTableHead}>#</TableCell>
                                                <TableCell sx={sxTableHead}>Clientes</TableCell>
                                                <TableCell sx={sxTableHead}>Prestamista</TableCell>
                                                <TableCell sx={sxTableHead}>Comienza</TableCell>
                                                <TableCell sx={sxTableHead}>Primer Pago</TableCell>
                                                <TableCell sx={sxTableHead}>Tipo Préstamo</TableCell>
                                                <TableCell sx={sxTableHead}>Tipo Pago</TableCell>
                                                <TableCell sx={sxTableHead}>Meses</TableCell>
                                                <TableCell sx={sxTableHead}>Acciones</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            <AnimatePresence component={null}>
                                                {prestamosPendientes.map((pp, index) => (
                                                    <motion.tr
                                                        key={pp.contratoPrestamoGrupalId}
                                                        initial={{ opacity: 0, x: -50 }}
                                                        animate={{ opacity: 1, x: 0 }}
                                                        exit={{ opacity: 0, y: -40 }}
                                                        transition={{
                                                            duration: 0.4,
                                                            ease: "easeOut",
                                                            delay: 0.1 * index
                                                        }}
                                                        style={{
                                                            backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                                        }}
                                                    >
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>
                                                            <Tooltip text={'VER INFORMACIÓN DE CLIENTES'} position="bottom">
                                                                <SupervisedUserCircleIcon fontSize="large" className="pointer" onClick={(e) => verInformacionClientes(e, pp.contratoPrestamoGrupalId)} />
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell>{pp.nombreusuario}</TableCell>
                                                        <TableCell>{formatFecha(pp.fechaComienzaContrato)}</TableCell>
                                                        <TableCell>{formatFecha(pp.fechaPrimerPagoContrato)}</TableCell>
                                                        <TableCell>{pp.tipoPrestamo}</TableCell>
                                                        <TableCell>{pp.tipoPago}</TableCell>
                                                        <TableCell>{pp.meses}</TableCell>
                                                        <TableCell>
                                                            <Tooltip text='AUTORIZAR' position="bottom">
                                                                <ThumbUpOffAltIcon className="text-success pointer" onClick={(e) => cambiarEstatusPrestamo(e, 1, 'AUTORIZADO', pp)} />
                                                            </Tooltip>
                                                            &nbsp; &nbsp;
                                                            <Tooltip text='DENEGAR' position="bottom">
                                                                <ThumbDownOffAltIcon className="text-danger pointer" onClick={(e) => cambiarEstatusPrestamo(e, 5, 'DENEGADO', pp)} />
                                                            </Tooltip>
                                                        </TableCell>
                                                    </motion.tr>
                                                ))}
                                            </AnimatePresence>
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        component="div"
                                        count={prestamosPendientes.length}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        labelRowsPerPage="Registros por página"
                                        rowsPerPageOptions={[5, 10, 25, 50]}
                                    />
                                </TableContainer>
                            </motion.div>




                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />

            <ModalInfoPrestamoClientes
                open={modalInfoPrestamoClientes}
                onClose={() => setModalInfoPrestamoClientes(false)}
                idpg={idPrestamoGrupal}
            />
        </div>
    )

}

export default AutorizarPrestamoGrupal